import { useLocation, useNavigate } from "react-router-dom";
import { CalendarPlus, PawPrint, ClipboardList, IndianRupee, MessageCircle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const WHATSAPP_URL =
  "https://wa.me/918088785201?text=" +
  encodeURIComponent("Hi WhatTheBark, I need help with my account / booking.");

const TABS = [
  { key: "book", label: "Book", Icon: CalendarPlus, to: "/account/book" },
  { key: "pups", label: "Pups", Icon: PawPrint, to: "/account" },
  { key: "bookings", label: "Bookings", Icon: ClipboardList, to: "/account/bookings" },
  { key: "rates", label: "Rates", Icon: IndianRupee, to: "/account/rates" },
  { key: "support", label: "Support", Icon: MessageCircle, external: WHATSAPP_URL },
];

export const BottomTabBar = () => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  if (!user || user.role === "admin") return null;

  const activeKey = (() => {
    if (pathname === "/account/book") return "book";
    if (pathname === "/account/rates") return "rates";
    if (pathname === "/account/bookings") return "bookings";
    if (pathname === "/account") return "pups";
    return "";
  })();

  const go = (tab) => {
    if (tab.external) {
      window.open(tab.external, "_blank", "noopener");
    } else {
      navigate(tab.to);
    }
  };

  return (
    <nav
      data-testid="bottom-tab-bar"
      aria-label="Account navigation"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-ink/10 bg-cream/95 pb-[env(safe-area-inset-bottom)] backdrop-blur-xl md:hidden"
    >
      <div className="mx-auto flex max-w-lg items-stretch justify-between px-2">
        {TABS.map((tab) => {
          const active = activeKey === tab.key;
          return (
            <button
              key={tab.key}
              type="button"
              data-testid={`tab-${tab.key}`}
              onClick={() => go(tab)}
              className={`flex flex-1 flex-col items-center gap-1 py-2.5 text-[11px] font-semibold transition-colors duration-200 ${
                active ? "text-bark" : "text-navy/55"
              }`}
            >
              <tab.Icon className={`h-5 w-5 ${active ? "text-bark" : "text-navy/55"}`} aria-hidden="true" />
              {tab.label}
            </button>
          );
        })}
      </div>
    </nav>
  );
};
